<div *ngIf="to.description" [innerHTML]="to.description | safe:'html'"></div>